import {
  isFirstKey,
  isLastKey,
  isNextKey,
  isNextVerticalKey,
  isPrevKey,
  isPrevVerticalKey
} from './keys';

export const resolveNextIndexWithoutLoop = (event, index, lastIndex) => {
  if (isNextVerticalKey(event)) {
    return Math.min(index + 1, lastIndex);
  }

  if (isPrevVerticalKey(event)) {
    return Math.max(index - 1, 0);
  }

  if (isFirstKey(event)) {
    return 0;
  }

  if (isLastKey(event)) {
    return lastIndex;
  }

  return null;
};

export const resolveNextIndexWithLoop = (event, index, length) => {
  if (isNextKey(event)) {
    return (index + 1) % length;
  }

  if (isPrevKey(event)) {
    return (index - 1 + length) % length;
  }

  if (isFirstKey(event)) {
    return 0;
  }

  if (isLastKey(event)) {
    return length - 1;
  }

  return null;
};
